import AdminLogin from '../../Admin/Login/Login';
import ForgotPassword from '../Auth/ForgotPassword/pages/ForgotPassword';
// import Login from '../Auth/Login/pages/Login';
import OtpVerification from '../Auth/OTPVerification/pages/OtpVerification';
import ResetPassword from '../Auth/ResetPassword/pages/ResetPassword';
import Signup from '../Auth/Signup/pages/Signup';

// import Report from './UserPages/Report/Report';
// import Dashboard from './Dashboard/Dashboard';
const AuthenticationRoutes = [
  {
    path: '/',
    element: <AdminLogin />,
  },
  {
    path: '/sign-up',
    element: <Signup />,
  },
  {
    path: '/sign-up/:id',
    element: <Signup />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/admin-login',
    element: <AdminLogin />,
  },
  {
    path: '/otp-verification',
    element: <OtpVerification />,
  },
  // {
  //   path: '/report',
  //   element: <Report />,
  //   allowedRoles: ['user', 'client'],
  // },
];

export default AuthenticationRoutes;
